import en from './en.json';
import tr from './tr.json';

export const NS = 'theme-solar-pv';
export const locales = [{ ns: NS, resources: { en, tr } }];
